import React, { useState, useContext, useRef, useEffect } from 'react';
import './login.css';
import axios from 'axios';
import { baseURL } from '../../constants/const'; 
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthProvider';
import { Avatar, Button, CssBaseline, TextField, Typography, Container } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next';
import { decrypt, decryptToken, encrypt } from '../../utils/Crypto';
import { getPagePermissions } from '../../api/axios';

const LOGIN_ENDPOINT = baseURL+'/login';
const CHECK_AUTH_ENDPOINT = baseURL+'/check-auth';

const Login = () => {
    const {setAuth} = useContext(AuthContext);
    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [company, setCompany] = useState('');

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const { t } = useTranslation('global');

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formData = new URLSearchParams();
        formData.append('user', user);
        formData.append('pwd', pwd);
        formData.append('company', company);
        if(user && pwd && company)
        {
            try {
                const response = await axios.post(LOGIN_ENDPOINT, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                });    
                const accessToken = response?.data?.accessToken;
                setAuth({ user, accessToken });
                localStorage.setItem('accessToken', accessToken);
                const pagePermissions = await getPagePermissions(accessToken);
                const encryptedPermissions = await encrypt(pagePermissions);
                localStorage.setItem('pagePermissions', encryptedPermissions);

                setUser('');
                setPwd('');
                setCompany('');
                setSuccess(true);
                navigate('/');
            } catch (error) {
                if (!error?.response) {
                    setErrMsg(t('login.noServerResponse'));
                    console.error(error.toJSON());
                } else if (error.response?.status === 401) {
                    setErrMsg(t('login.loginFailed'));
                } else if (error.response?.status === 404) {
                    setErrMsg(t('login.loginFailed'));
                } else if (error.response?.status === 500) {
                    setErrMsg(t('login.unknownError'));
                } else {
                    setErrMsg(t('login.loginFailed'));
                }
                errRef.current.focus();
            }
        }
        else{
            setErrMsg(t('login.fillAllTheFields'));
        }
        
    }

    return (
        <>
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Avatar style={{ margin: '8px', backgroundColor: '#f50057' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                {t('login.login')}
                </Typography>
                <form onSubmit={handleSubmit} style={{ width: '100%', marginTop: '8px' }} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label={t('login.username')}
                        autoComplete="off"
                        ref={userRef}
                        onChange={(e) => setUser(e.target.value)}
                        value={user}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="password"
                        label={t('login.password')}
                        type="password"
                        autoComplete="off"
                        onChange={(e) => setPwd(e.target.value)}
                        value={pwd}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="company"
                        label={t('login.company')}
                        autoComplete="off"
                        onChange={(e) => setCompany(e.target.value)}
                        value={company}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ margin: '24px 0 16px' }}
                    >
                        {t('login.login')}
                    </Button>
                    <p ref={errRef} className={errMsg ? "errMsg" : "offscreen"} aria-live='assertive'>{errMsg}</p>
                </form>
            </div>
        </Container>
        </>
    );
};

export default Login;